// marked_at_device is the teacher's device wall-clock time (already IST).
// created_at is the server timestamp in UTC without a timezone marker.
// These helpers keep those semantics separate so display always shows IST.

function formatIsoWallClock(iso: string): string {
  const m = /T(\d{2}):(\d{2})/.exec(iso);
  if (!m) return '';
  let hour = parseInt(m[1], 10);
  const minute = m[2];
  const period = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12 || 12;
  return `${String(hour).padStart(2, '0')}:${minute} ${period}`;
}

function formatUtcAsIst(iso: string): string {
  const hasTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(iso);
  const ts = Date.parse(hasTz ? iso : `${iso}Z`);
  if (Number.isNaN(ts)) return '';
  return new Date(ts)
    .toLocaleTimeString('en-IN', {
      hour: '2-digit', minute: '2-digit', hour12: true,
      timeZone: 'Asia/Kolkata',
    })
    .toUpperCase();
}

export function formatMarkedTime(
  markedAtDevice?: string | null,
  createdAt?: string | null,
): string {
  if (markedAtDevice) return formatIsoWallClock(markedAtDevice);
  if (createdAt)      return formatUtcAsIst(createdAt);
  return '';
}
